module.exports = __webpack_public_path__ + "assets/img/open-component.cf603f01.png";